#import "../fragments/form-page-fragment.graphql"

mutation UpdateFormPageRules($input: FormPageRulesUpdateInput!) {
    formPageRulesUpdate(input: $input) {
        page {
            ...FormPageFragment
        }
    }
}
